module.exports = __webpack_public_path__ + "img/brzj.c0d9d345.png";